import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useFieldArray } from "react-hook-form";
import Select from "react-select";

import { displayFormAlert } from "../../../../../lib/utils";
import { IPlayer } from "../../../../../types/api";
import { useGameSummaryContext } from "../contexts/GameSummary";

const PitchCounts = (): React.JSX.Element => {
    const { methods, game, homeRoster, visitorRoster } =
        useGameSummaryContext();

    const {
        fields: homePitchCounts,
        append: appendHPC,
        remove: removeHPC,
    } = useFieldArray({
        control: methods.control,
        name: "pitchCounts.home",
    });

    const {
        fields: visitorPitchCounts,
        append: appendVPC,
        remove: removeVPC,
    } = useFieldArray({
        control: methods.control,
        name: "pitchCounts.visitor",
    });

    return (
        <section className="pitchCounts" data-testid="pitchCounts">
            <h3>Pitch Counts</h3>
            {(["home", "visitor"] as Array<"home" | "visitor">).map(t => {
                let pitchCounts;
                let roster: IPlayer[];
                switch (t) {
                    case "home":
                        pitchCounts = homePitchCounts;
                        roster = homeRoster;
                        break;
                    case "visitor":
                        pitchCounts = visitorPitchCounts;
                        roster = visitorRoster;
                        break;
                }

                return (
                    <Row key={t} data-testid={`${t}-pitchCounts`}>
                        <Col>
                            <h5>
                                {t === "home"
                                    ? game.home.name
                                    : game.visitor.name}{" "}
                                Pitch Counts
                            </h5>
                            {pitchCounts &&
                                pitchCounts.map((player, index) => {
                                    return (
                                        <Row
                                            key={index}
                                            className="mb-3 mb-sm-2 pb-3 pb-sm-2 border-bottom"
                                        >
                                            <Col
                                                xs={12}
                                                sm={6}
                                                md={7}
                                                xl={8}
                                                className="mb-1 mb-sm-0"
                                            >
                                                <Controller
                                                    name={`pitchCounts.${t}.${index}.player`}
                                                    control={methods.control}
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            aria-labelledby={`pitchCounts.${t}.${index}.player`}
                                                            isSearchable={true}
                                                            options={roster
                                                                .filter(
                                                                    p =>
                                                                        p.active ===
                                                                        1,
                                                                )
                                                                .map(p => {
                                                                    return {
                                                                        value: parseInt(
                                                                            p.id.toString(),
                                                                        ),
                                                                        label: `${p.firstName} ${p.lastName}`,
                                                                    };
                                                                })
                                                                .sort((a, b) =>
                                                                    a.label.localeCompare(
                                                                        b.label,
                                                                    ),
                                                                )}
                                                        />
                                                    )}
                                                />
                                            </Col>
                                            <Col xs={6} sm={2}>
                                                <Form.Control
                                                    {...methods.register(
                                                        `pitchCounts.${t}.${index}.count` as const,
                                                    )}
                                                    type="text"
                                                    data-testid={`pitchCounts.${t}.${index}.count`}
                                                    aria-invalid={
                                                        methods.formState.errors
                                                            .pitchCounts?.[t] &&
                                                        methods.formState.errors
                                                            .pitchCounts?.[t]?.[
                                                            index
                                                        ]
                                                            ? "true"
                                                            : "false"
                                                    }
                                                />
                                                {methods.formState.errors
                                                    .pitchCounts?.[t]?.[index]
                                                    ?.count?.message &&
                                                    displayFormAlert({
                                                        level: "danger",
                                                        text: methods.formState
                                                            .errors
                                                            .pitchCounts?.[t]?.[
                                                            index
                                                        ]?.count
                                                            ?.message as string,
                                                    })}
                                            </Col>
                                            <Col
                                                xs={6}
                                                sm={4}
                                                md={3}
                                                xl={2}
                                                className="d-md-flex justify-content-md-end"
                                            >
                                                <Button
                                                    type="button"
                                                    className="no-margin-btn"
                                                    onClick={() =>
                                                        t === "home"
                                                            ? removeHPC(index)
                                                            : removeVPC(index)
                                                    }
                                                >
                                                    Remove Entry
                                                </Button>
                                            </Col>
                                        </Row>
                                    );
                                })}
                            <Row className="mb-5">
                                <Col>
                                    <Button
                                        type="button"
                                        className="no-margin-btn"
                                        onClick={() => {
                                            const addValue = {
                                                player: {
                                                    value: 0,
                                                    label: "",
                                                },
                                                count: 0,
                                            };

                                            return t === "home"
                                                ? appendHPC(addValue, {
                                                      shouldFocus: false,
                                                  })
                                                : appendVPC(addValue, {
                                                      shouldFocus: false,
                                                  });
                                        }}
                                    >
                                        Add Row
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                );
            })}
        </section>
    );
};

export default PitchCounts;
